module.exports = __webpack_public_path__ + "img/fi-rr-screen.cc28a58e.svg";